<template>
  <div class="watchlist">
    <SidebarTitle :title="title" />
    <div v-for="(topic, index) in links" :key="index" class="watchlist__topic">
      <SidebarTitle
        v-if="topic.options.length"
        :title="topic.label"
        :size="'small'"
      />
      <div class="watchlist__links">
        <div
          v-for="(link, index2) in topic.options"
          :key="index2"
          class="watchlist__link"
        >
          <p>
            {{ link.name }}
          </p>
          <Button
            :style-class="
              topic.value.some((el) => el === link.tid)
                ? 'red small upper'
                : 'blue small upper'
            "
            :text="
              topic.value.some((el) => el === link.tid) ? 'watching' : 'watch'
            "
            @clickButton="
              changeStatus(
                topic.name,
                topic.value.some((el) => el === link.tid),
                link.tid,
                link.name
              )
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../../nuxt.config";

export default {
  name: "Watchlist",
  components: {
    SidebarTitle: () => import("./SidebarTitle"),
    Button: () => import("../../components/elements/Button"),
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    links: {
      type: Array,
      default: null,
    },
  },
  methods: {
    changeStatus(parent, status, id, sectorName) {
      this.loadingData = true;
      let method = "";
      status ? (method = "DELETE") : (method = "POST");
      const data = {};
      id = +id;
      data[parent] = [id];
      this.$axios({
        method,
        url: `${config.env.JSON_API_URL}/user/watchlist`,
        data,
      })
        .then((data) => {
          this.$emit("updateWatchList");
        })
        .catch((error) => {
          this.loadingData = true;
          console.error(error);
        });
      if (this.$matomo) {
        const name = status
          ? "Watchlist Remove Sector"
          : "Watchlist Add Sector";
        console.log("Engagement Click", name, sectorName);
        this.$matomo.trackEvent("Engagement Click", name, sectorName);
      }
      if (this.$churnZero) {
        const name = status
          ? "Watchlist Remove Sector"
          : "Watchlist Add Sector";
        this.$churnZero.trackEvent("Engagement Click", name);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.watchlist {
  &__links {
    padding-right: 1.6rem;
    margin-bottom: 2.4rem;
  }
  &__link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
    color: $red;
    font-size: 1.4rem;
    font-weight: 600;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
